import classnames from 'classnames';
import update from 'immutability-helper';

import styles from './AlertBar.scss';

const stateStyles = (additionalClasses = []) => ({
  error: classnames(styles.error, ...additionalClasses),
  warning: classnames(styles.warning, ...additionalClasses),
  success: classnames(styles.success, ...additionalClasses),
  info: classnames(styles.info, ...additionalClasses),
});

const combinedStyles = {
  alertBar: stateStyles([styles.alertBar]),
  icon: stateStyles([styles.icon]),
};

export default update(styles, { $merge: combinedStyles });